export const APPOINTMENT_CALLER = ['staff', 'portal', 'kiosk', 'encounter', 'sweep', 'tele'];
export const APPOINTMENT_CANCEL_REASON = [
    'patient_request',
    'patient_unwell',
    'doctor_unavailable',
    'booked_in_error',
    'clinic_closed',
    'rebooked',
    'other',
];
export const APPOINTMENT_NO_SHOW_REASON = ['did_not_attend', 'left_without_consultation', 'auto_end_of_day'];
export const APPOINTMENT_CONFIRMED_VIA = ['desk', 'portal'];
export const APPOINTMENT_PRIORITY = ['routine', 'urgent'];
export const APPOINTMENT_PRIORITY_REASON = ['clinical', 'elderly', 'disability', 'pregnant', 'child'];
export const CARE_TEAM_ROLE = ['consulting', 'assisting', 'resident', 'nurse', 'anaesthetist'];
export const CERTIFICATE_AUTHORITY = ['seha'];
export const PAID_NO_SHOW_POLICY = ['refund_due', 'keep'];
const TRANSITIONS = {
    staff: {
        booked: ['confirmed', 'arrived', 'cancelled', 'no_show'],
        confirmed: ['arrived', 'cancelled', 'no_show'],
        arrived: ['cancelled', 'no_show'],
        in_consultation: ['completed'],
        no_show: ['booked'],
    },
    portal: {
        booked: ['confirmed', 'cancelled'],
        confirmed: ['cancelled'],
    },
    kiosk: {
        booked: ['arrived'],
        confirmed: ['arrived'],
    },
    encounter: {
        arrived: ['in_consultation'],
        in_consultation: ['completed'],
    },
    sweep: {
        booked: ['no_show'],
        confirmed: ['no_show'],
        arrived: ['no_show'],
    },
    tele: {
        booked: ['arrived'],
        confirmed: ['arrived'],
    },
};
export function allowedTransitions(caller, from, options = {}) {
    const allowed = [...(TRANSITIONS[caller][from] ?? [])];
    if (caller === 'encounter' && options.startWithoutArrival && (from === 'booked' || from === 'confirmed')) {
        allowed.push('in_consultation');
    }
    return allowed;
}
export function mayTransition(caller, from, to, options = {}) {
    return allowedTransitions(caller, from, options).includes(to);
}
export function noShowReasonFor(from, caller) {
    if (from === 'arrived')
        return 'left_without_consultation';
    return caller === 'sweep' ? 'auto_end_of_day' : 'did_not_attend';
}
//# sourceMappingURL=appointment-transitions.js.map